exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pages-AccountsPage .pending {\n  background: #FFEEAA; }\n", ""]);

// exports
